import moment from "moment";
import { Role } from '@/helper/Role';
import { authenticationService } from "@/services/AuthenticationService";
import Vue from 'vue';


export const getPermissions = function (permissions, access, redirect, moduleID, accessID) {
    let roleArray = []
    let checkperm = false

    let modules = []

    let roleID = null

    if (authenticationService.get("USINFO")) {
        roleID = authenticationService.get("USINFO").role_id
    }
    let module_list = authenticationService.get("module_list")
    // console.log('module_list :>> ', module_list);

    if (roleID == 1 || roleID == 2 || roleID == 3 || roleID == 8 || roleID == 9) {
        return checkperm = true
    } else if (roleID != 1 && roleID != 2 && roleID != 3 && roleID != 4 && roleID != 5 && roleID != 6 && roleID != 7 && roleID != 8 && roleID != 9) {
        if (module_list && module_list.includes(moduleID)) {
            checkperm = true
        }else{
            let promise = permissions.map((x) => {
            if (Role.hasOwnProperty(x)) {
                roleArray.push({
                    role: Role[x],
                    access: access,
                    redirect: redirect
                })
            }
            return x;
        });
        Promise.all(promise)
        return roleArray;
    }
    }
    else {
        let promise = permissions.map((x) => {
            if (Role.hasOwnProperty(x)) {
                roleArray.push({
                    role: Role[x],
                    access: access,
                    redirect: redirect
                })
            }
            return x;
        });
        Promise.all(promise)
        return roleArray;
    }
}

export const addAllKeyWordsIntoArrays = (array, key) => {
    if (array.length > 0) {
        let Obj = { ...array[0] };
        Object.keys(Obj).map((x) => { Obj[x] = null; key ? Obj[key] = 'All' : '' });
        return [Obj].concat(array);
    } else return array;
};

export const addAllKeyWordsIntoArrays_2 = (array, key) => {
    if (array.length > 0) {
        let Obj = { ...array[0] };
        Object.keys(Obj).map((x) => { Obj[x] = null; key ? Obj[key] = 'All' : '' });
        return [Obj].concat(array);
    } else return array;
};

export const generateRandomCode = (max) => {
    return Math.floor(Math.pow(10, max - 1) + Math.random() * (Math.pow(10, max) - Math.pow(10, max - 1) - 1));
    // return Array(max).fill('').reduce((accumulator) => accumulator += Math.floor(Math.random() * (max - 2) + 2), '');
};

export const UniqueRandomNumber = () => {
    let u_number = Math.floor(new Date().valueOf() * Math.random())
    return new String(u_number).substring(0, 8);
  }

export const removeDuplicates = (originalArray, prop) => {
    var newArray = [];
    var lookupObject = {};

    for (var i in originalArray) {
        lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for (i in lookupObject) {
        newArray.push(lookupObject[i]);
    }
    return newArray;
};

export const movieWeekEnd = (date) => {
    const dayINeed = 5;
    let startDate = moment(date);
    let FinalDate = null;
    if (startDate.isoWeekday() === 5) {
        startDate.add(1, 'days');
    };
    while (startDate.isoWeekday() !== dayINeed) {
        let d = startDate;
        FinalDate = d.format();
        startDate.add(1, 'days');
    };
    return FinalDate;
};


// WEBPACK FOOTER //
// ./src/helper/collection.js